export const teamRegistrationInitialState = {
    payer: null,
    wizardState: null,
    divisions: null,
    isMC: true,
    selectedPaymentOption: null,
    teamPriceAdjustments: null,
    totalPricingAdjustmentAmount: 0,
    paymentPricing: null,
};
export function teamRegistrationReducer(state = teamRegistrationInitialState, action) {
    switch (action.type) {
        case 'SET_PAYER': {
            return Object.assign(Object.assign({}, state), { payer: action.payload.payer });
        }
        case 'SET_WIZARD_STATE': {
            return Object.assign(Object.assign({}, state), { wizardState: action.payload.wizardState });
        }
        case 'SET_DIVISIONS': {
            return Object.assign(Object.assign({}, state), { divisions: action.payload.divisions });
        }
        case 'SET_SELECTED_PAYMENT_OPTION': {
            return Object.assign(Object.assign({}, state), { selectedPaymentOption: action.payload.optionId });
        }
        case 'SET_PRICING_DETAILS': {
            return Object.assign(Object.assign({}, state), { teamPriceAdjustments: action.payload.teamPriceAdjustments, totalPricingAdjustmentAmount: action.payload.totalPriceAdjustmentAmount });
        }
        case 'SET_PAYMENTS_PRICING': {
            return Object.assign(Object.assign({}, state), { paymentPricing: action.payload.paymentsPricing });
        }
    }
}
